module.exports = __webpack_public_path__ + "static/media/IMG_0800.f605141a.jpg";